import styled from 'styled-components';

export const ModalContent = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 1.5rem;
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem 1.5rem;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  min-width: 0;

  > p {
    margin: 0 0 0.5rem;
  }
`;
